import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import menuHelper from '../../menu.helper';
import userStore from '../../../../store/domain/user/user.store';

const UserMenu = observer(() => {
    const location = useLocation();
    const { t } = useTranslation('menu');
    const accountsUserURL = menuHelper.getAccountsUserURL(location);
    const isMtls = userStore.user && userStore.user.authenticationType === 'MTLS';

    return accountsUserURL && (
        <div className="sub__menu">
            <NavLink
                end
                className={({ isActive }) => isActive ? "menu__item is-active" : "menu__item"}
                to={accountsUserURL}>
                {t("menu.account.users.overview")}
            </NavLink>
            {isMtls &&
                <NavLink
                    className={({ isActive }) => isActive ? "menu__item is-active" : "menu__item"}
                    to={`${accountsUserURL}/identities`}>
                    {t("menu.account.users.identities")}
                </NavLink>
            }
            <NavLink
                className={({ isActive }) => isActive ? "menu__item is-active" : "menu__item"}
                to={`${accountsUserURL}/login-history`}>
                {t("menu.account.users.login.history")}
            </NavLink>
            <NavLink
                className={({ isActive }) => isActive ? "menu__item is-active" : "menu__item"}
                to={`${accountsUserURL}/transactions`}>
                Transactions
            </NavLink>
            <NavLink
                className={({ isActive }) => isActive ? "menu__item is-active" : "menu__item"}
                to={`${accountsUserURL}/profiles`}>
                {t("menu.account.users.profiles")}
            </NavLink>
            <NavLink
                className={({ isActive }) => isActive ? "menu__item is-active" : "menu__item"}
                to={`${accountsUserURL}/policy-run-history`}>
                {t("menu.account.users.policy.run.history")}
            </NavLink>
        </div>
    );
});

export default UserMenu;
